import { StringMap } from '../common/interfaces/stringMap';

export const BrandColors: StringMap = {
  white: '#FFFFFF',
  black: '#000000',
  blackPearl: '#181C1E',
  standardTCColor: '#046ca3',
  blackWithOpacity1: 'rgba(0, 0, 0, 0.1)',
  blackWithOpacity9: 'rgba(0, 0, 0, 0.9)',
  blackWithOpacity765: 'rgba(0, 0, 0, 0.765)',
  blackWithOpacity15: 'rgba(0, 0, 0, 0.15)',
  blackWithOpacity25: 'rgba(0, 0, 0, 0.25)',
  blackWithOpacity20: 'rgba(0, 0, 0, 0.20)',
  blackWithOpacity08: 'rgba(0, 0, 0, 0.08)',
  grey100: '#989A98',
  grey99: '#E7EBEE',
  grey98: '#FAFAFA',
  grey95: '#F2F2F2',
  grey90: '#E5E5E5',
  grey89: '#E0E0E0',
  grey88: '#DEE1E2',
  grey80: '#CED1D4',
  grey77: '#C4C4C4',
  grey40: '#5B6770',
  grey41: '#5D676F',
  grey35: '#4F4F4F',
  grey30: '#434C53',
  grey29: '#6D706E',
  borderGrey: '#E4E4E4',
  lightGrey40: 'rgba(91, 103, 112, 0.5)',
  lightGrey40WithOpacity25: 'rgba(91, 103, 112, 0.25)',
  grey33: '#555555',
  grey25: '#323130',
  grey20: '#333333',
  grey15: '#4A4A4A',
  grey14: '#F2F3F4',
  red39: '#C70000',
  lightRed39: 'rgba(199, 0, 0, 0.05)',
  blue20: '#005366',
  green57: '#78D64B',
  green20: '#00664D',
  green25: '#4DA94B',
  amber500: '#ffc107',
  muiLink: '#1976d2',
  link: '#1FB3E0',
  link1: '#3344DD',
  transparent: '#00000000',
  scoreCardBg: `rgba(254, 254, 254, 0)`,
  lightGreenColor: `rgba(106, 189, 53, 0.5)`,
  scoreCardBorder: '#828282',
  chartColor: '#CCCCCC',
  darkblue: '#1ca1ca',
  green47: '#6ABD35',
  pageDefaultColor: '#3e464d',
  modalBackdropColor: 'rgba(119, 119, 119, 0.7)',
  defaultProgressBarColor: '#5A6771',
  selectionColor: '#2196f3',
  mineShaftWithOpacity8: 'rgba(52, 52, 52, 0.8)',
  mineShaftWithOpacity9: 'rgba(52, 52, 52, 0.9)',
  tileBorderColor: 'rgba(119, 119, 119, 0.2)',
  inputBorderColor: 'rgba(0, 0, 0, 0.23)',
  tileBoxShadow: 'rgba(91, 103, 112, 0.1)',
  grey13: '#6B6B6B',
  passwordValidationSuccess: '#2c792a',
  focusOutline: '#3075de',
};

export enum ButtonStyle {
  STYLE_1 = 'STYLE_1',
  STYLE_2 = 'STYLE_2',
}
